import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getBatchStatus } from "api/invoice.api";

export const useGetBatchStatus = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["batchInfo"],
    queryFn: () => getBatchStatus(),
    initialData: () => queryClient.getQueryData(["batchInfo"]),
    select: (data) => data.batches,
    staleTime: 1000 * 60 * 5, // 5 minutes
    onError: (error) => {
      console.log("Error fetching batch status:", error);
    },
  });
};
